module.exports = __webpack_public_path__ + "static/media/menu_status.cd38cd20.png";